module.exports = __webpack_public_path__ + "static/dept-of-speculation-d6924703d16d739368a875c5ffe8a851.jpg";